import ButtonGroupYesNoWithLabel from "@/components/ui/molecules/ButtonGroupYesNoWithLabel/ButtonGroupYesNoWithLabel"
import { useSelectedLinkContext } from "@/contexts";
import { SAVE_DEVICE_SETTINGS } from "@/graphql/admin/settings/SettingsMutations";
import { GET_DEVICE_SOUND_SETTINGS } from "@/graphql/admin/settings/SettingsQueries";
import { QueryGetSoundSettingsResponse, SoundSettings } from "@/types/settings.types";
import { FetchResult, useMutation, useQuery } from "@apollo/client";

const AdminSettingsSoundPage = (): JSX.Element => {

  const { selectedLink } = useSelectedLinkContext();
  const { data, refetch } = useQuery<QueryGetSoundSettingsResponse>(
    GET_DEVICE_SOUND_SETTINGS,
    {
      variables: {
        getDeviceSettingsInput: {
          channel: selectedLink?.channelKey,
        }
      },
    },
  );

  const [saveSoundSettingsGQL] = useMutation<any>(SAVE_DEVICE_SETTINGS);
  const saveSoundDeviceSettings = (settings: SoundSettings): Promise<FetchResult<any>> => {
    return saveSoundSettingsGQL({
      variables: {
        saveDeviceSettingsInput: {
          channel: selectedLink.channelKey,
          settings: settings,
        },
      },
    });
  }

  const updateCommunicationSettings = (settings: SoundSettings): void => {
    saveSoundDeviceSettings(settings)
      .then(() => {
        void refetch();
      }).catch((error) => {
        console.log(error);
      });
  }

  return (
    <div className="flex flex-col gap-2w bg-neutral-100">
      <h2 className="text-header3 text-white p-2w bg-admin-darkblue-300">Son</h2>
      <div className="flex flex-col gap-4w p-2w m-2w rounded-2xl bg-white">
        <ButtonGroupYesNoWithLabel 
          label="Jouer un son lors d'un appui sur un bouton"
          value={data?.getDeviceSettings?.settings?.soundOnButtonPush}
          onChange={(value) => updateCommunicationSettings({soundOnButtonPush: value})}
        />
        <ButtonGroupYesNoWithLabel 
          label="Jouer un son lors d'un appui sur une touche du clavier tactile"
          value={data?.getDeviceSettings?.settings?.soundOnKeyPush}
          onChange={(value) => updateCommunicationSettings({soundOnKeyPush: value})}
        />
        <ButtonGroupYesNoWithLabel 
          label="Jouer un son lors de la réception d'un message provenant d'une adresse autorisée"
          value={data?.getDeviceSettings?.settings?.soundOnAllowedMailReception}
          onChange={(value) => updateCommunicationSettings({soundOnAllowedMailReception: value})}
        />
        <ButtonGroupYesNoWithLabel 
          label="Jouer un son lors de la réception d'un message provenant d'une adresse non autorisée"
          value={data?.getDeviceSettings?.settings?.soundOnForbiddenMailReception}
          onChange={(value) => updateCommunicationSettings({soundOnForbiddenMailReception: value})}
        />
        <ButtonGroupYesNoWithLabel 
          label="Jouer un son lors de la réception d'un appel vidéo Ardoiz"
          value={data?.getDeviceSettings?.settings?.soundOnVideoCall}
          onChange={(value) => updateCommunicationSettings({soundOnVideoCall: value})}
        />
      </div>
    </div>
  )
}

export default AdminSettingsSoundPage;